<template>
  <div class="login-container">
    <div class="signup-wizard">
      <div class="steps-container">
        <div class="login-container" v-if="valid">
          <LogoIcon class="logo-icon" />
          <span class="title">Complete the Registration</span>
          <div class="login-content">
            <div class="inputs">
              <div class="floating-label">
                <input
                  v-model="first_name"
                  placeholder="First Name"
                  type="text"
                  name="first_name"
                  id="first_name"
                  autocomplete="off"
                />
                <label for="first_name">First Name</label>
              </div>
              <div class="floating-label">
                <input
                  v-model="last_name"
                  placeholder="Larst Name"
                  type="text"
                  name="last_name"
                  id="last_name"
                  autocomplete="off"
                />
                <label for="last_name">Last Name</label>
              </div>
              <div class="floating-label">
                <input
                  v-model="password"
                  placeholder="Enter password"
                  type="password"
                  name="password"
                  id="password"
                  autocomplete="off"
                />
                <label for="password">Password</label>
              </div>
            </div>
            <button
              @click="completeRegistration()"
              class="button-default big continue"
              :disabled="!formValid || isLoading"
            >
              <span>Continue</span>
            </button>
          </div>
        </div>
      </div>
      <SnackBar>
        <template v-slot:icon></template>
      </SnackBar>
    </div>
  </div>
</template>
<script>
import LogoIcon from "@/components/AppLogo";
import SnackBar from "@/components/Custom/SnackBar";
import { Q_CHECK_INVITATION, M_REGISTER_INVITED } from "@/graphql";

export default {
  name: "CompleteRegistration",
  components: { SnackBar, LogoIcon },
  data() {
    return {
      first_name: null,
      last_name: null,
      password: null,
      isLoading: false,
      valid: false
    };
  },
  computed: {
    invitation() {
      return this.$route.query.invitation;
    },
    formValid() {
      return this.first_name && this.last_name && this.password;
    }
  },
  async mounted() {
    this.valid = false;
    const { data } = await this.$apollo.mutate({
      mutation: Q_CHECK_INVITATION,
      variables: {
        token: this.invitation
      }
    });

    const {
      register_invitation_check: { status }
    } = data;

    if (status === "pending") this.valid = true;
    else if (status === "completed") {
      await this.$store.dispatch("snack", {
        type: "error",
        text: "Already completed your registration!"
      });
      await this.$router.push({ name: "LoginNew" });
    } else {
      await this.$store.dispatch("snack", {
        type: "error",
        text: "Invalid invitation!"
      });
      await this.$router.push({ name: "Homepage" });
    }
  },
  methods: {
    async completeRegistration() {
      try {
        this.isLoading = true;
        const result = await this.$apollo.mutate({
          mutation: M_REGISTER_INVITED,
          client: "localClient",
          variables: {
            token: this.invitation,
            first_name: this.first_name,
            last_name: this.last_name,
            password: this.password,
            coupon: ""
          }
        });
        console.log(result.data.register_invited);
        this.error = "";
        localStorage.setItem("token", result.data.register_invited.token);
        await this.$store.dispatch(
          "setUser",
          result.data.register_invited.user
        );
        await this.$store.dispatch(
          "setArtist",
          result.data.register_invited.user.artists[0]
        );
        window.location = "/links";
      } catch (err) {
        this.error = err.message.replace("GraphQL error: ", "");
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  /* BG/type2 */
  background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .signup-wizard {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    /* BG/type1 */
    background: $bg-type-1;
    .steps-container {
      flex: 1;
      display: flex;
      justify-content: center;
      overflow-y: auto;
      //padding: 60px 0;

      .login-container {
        width: 100vw;
        height: 100vh;
        /* BG/type2 */
        background: $bg-type-2;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .logo-icon {
          width: 54px;
        }
        .title {
          display: block;
          margin-top: 30px;
          font-weight: bold;
          font-size: 30px;
          line-height: 42px;
          /* White */
          color: #ffffff;
          mix-blend-mode: normal;
          opacity: 0.9;
        }
        .login-content {
          width: 300px;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0 12px;
          .inputs {
            margin-top: 30px;
            width: 100%;
            display: grid;
            grid-gap: 18px;
          }
          button.continue {
            margin-top: 22px;
            width: 100%;
          }
        }
      }
      @media (max-width: 600px) {
        .login-container {
          padding: 24px;
          .title {
            text-align: center;
          }
          .login-content {
            width: 100%;
            padding: 0;
            .inputs {
              grid-template-columns: repeat(1, 100%);
              width: 100%;
            }
          }
        }
      }
    }
  }
  @media (max-width: 600px) {
    .signup-wizard {
      .back {
        top: 24px;
        left: 24px;
        position: absolute;
      }
      .steps-container {
        display: block;
        overflow-y: initial;
      }
    }
  }
}
@media (max-width: 600px) {
  .login-container {
    height: auto;
    min-height: 100vh;
  }
}
</style>
